package screens.auth

import androidx.compose.runtime.*
import com.example.readingnotes.presentation.auth.AuthEvent
import com.example.readingnotes.presentation.auth.AuthViewModel
import com.example.readingnotes.resources.Strings
import components.QrCodeView
import org.jetbrains.compose.web.attributes.*
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*
import styles.AppStyleSheet

@Composable
fun TotpSetupScreen(
    onSetupComplete: () -> Unit,
    onBackClick: () -> Unit,
    authViewModel: AuthViewModel,
) {
    val state by authViewModel.state.collectAsState()

    // Load TOTP setup on appear
    LaunchedEffect(Unit) {
        if (state.totpSetupSecret == null) {
            authViewModel.onEvent(AuthEvent.OnSetupTotp)
        }
    }

    Div({ classes(AppStyleSheet.loginContainer) }) {
        Button({
            classes(AppStyleSheet.backButton)
            onClick { onBackClick() }
        }) { Text("← 戻る") }

        Div({ classes(AppStyleSheet.loginForm) }) {
            H2({ classes(AppStyleSheet.loginTitle) }) { Text(Strings.Auth.totpSetup) }

            when {
                state.isLoading -> {
                    Div({ classes(AppStyleSheet.loading) }) { Text(Strings.Auth.loading) }
                }
                state.totpSetupSecret != null -> {
                    P({ classes(AppStyleSheet.totpDescription) }) {
                        Text(Strings.Auth.totpSetupDescription)
                    }

                    // QR Code display
                    if (state.totpSetupQrCodeUrl != null) {
                        Div({
                            style {
                                display(DisplayStyle.Flex)
                                flexDirection(FlexDirection.Column)
                                alignItems(AlignItems.Center)
                                justifyContent(JustifyContent.Center)
                                margin(20.px, 20.px)
                                padding(20.px)
                                backgroundColor(Color("#FFFFFF"))
                                borderRadius(8.px)
                                property("box-shadow", "0px 2px 8px rgba(0, 0, 0, 0.1)")
                            }
                        }) {
                            QrCodeView(
                                data = state.totpSetupQrCodeUrl!!,
                                size = 200,
                                contentDescription = "TOTPセットアップ用QRコード"
                            )
                            P({
                                style {
                                    marginTop(10.px)
                                    fontSize(14.px)
                                    color(Color("#808080"))
                                }
                            }) {
                                Text(Strings.Auth.qrCodeScanHint)
                            }
                        }
                    }

                    // Secret key (manual entry)
                    Div({ classes(AppStyleSheet.totpQrSection) }) {
                        P { Text(Strings.Auth.manualEntryHint) }
                        Div({ classes(AppStyleSheet.secretKey) }) {
                            Text(state.totpSetupSecret!!)
                        }
                    }

                    // TOTP code input for verification
                    Div({ classes(AppStyleSheet.formGroup) }) {
                        Label("totp-setup-input") {
                            Text(Strings.Auth.totpVerifyLabel)
                        }

                        Input(type = InputType.Text) {
                            id("totp-setup-input")
                            classes(AppStyleSheet.totpInput)
                            value(state.totpCodeInput)
                            maxLength(6)
                            attr("pattern", "[0-9]{6}")
                            attr("inputmode", "numeric")
                            attr("autocomplete", "one-time-code")
                            attr("required", "true")
                            attr("aria-label", Strings.Auth.ariaTotpSetup)
                            attr("aria-describedby", "totp-setup-hint")
                            onInput { authViewModel.onEvent(AuthEvent.OnTotpCodeChanged(it.value)) }
                        }

                        // TOTP setup hint
                        P({
                            id("totp-setup-hint")
                            classes(AppStyleSheet.inputHint)
                        }) {
                            Text(Strings.Auth.totpVerifyDescription)
                        }
                    }

                    // Error message
                    if (state.errorMessage != null) {
                        Div({
                            classes(AppStyleSheet.formError)
                            attr("role", "alert")
                            attr("aria-live", "assertive")
                        }) { Text(state.errorMessage!!) }
                    }

                    // Verify and enable button
                    Div({ classes(AppStyleSheet.loginButtonGroup) }) {
                        Button({
                            classes(AppStyleSheet.submitButton)
                            onClick { authViewModel.onEvent(AuthEvent.OnVerifyTotpSubmit) }
                            if (state.totpCodeInput.length != 6) {
                                disabled()
                            }
                        }) { Text(Strings.Auth.verifyTotpButton) }
                    }

                    // Skip button
                    Div({ classes(AppStyleSheet.skipLink) }) {
                        Button({
                            classes(AppStyleSheet.linkStyle)
                            onClick { onSetupComplete() }
                        }) { Text(Strings.Auth.skipButton) }
                    }
                }
                state.errorMessage != null -> {
                    Div({ classes(AppStyleSheet.formError) }) { Text(state.errorMessage!!) }
                }
            }
        }
    }
}
